import { render } from "./getMoble.vue?vue&type=template&id=70e9be94"
import script from "./getMoble.vue?vue&type=script&lang=js"
export * from "./getMoble.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__